<button
  [matMenuTriggerFor]="menu"
  aria-label="Ouvrir le calendrier"
  class="date-range-filter-button"
>
  <div class="date-range-filter-button__label">
    <mat-icon
      svgIcon="dgi-calendar"
      class="date-range-filter-button__icon"
      aria-hidden="true"
    ></mat-icon>
    <span>Filtre :</span>

    @if (selectedTimeRangeName(); as name) {
      @if (name === 'CUSTOM' && selectedTimeRange(); as range) {
        <span>
          {{ range.start | date: 'dd/MM/yyyy' : undefined : 'fr' }} -
          {{ range.end | date: 'dd/MM/yyyy' : undefined : 'fr' }}
        </span>
      } @else {
        <span>{{ name | timeRange }}</span>
      }
    } @else {
      <span>{{ placeholder() }}</span>
    }
  </div>
  <svg-icon
    src="assets/icons/arrow.svg"
    [style]="{
      width: '16px',
      height: '16px',
      color: '#2B80FF',
      transform: 'rotate(180deg)'
    }"
  ></svg-icon>
</button>
<mat-menu #menu="matMenu">
  @if (selectedTimeRangeName(); as name) {
    <calendar
      [timeRangeView]="true"
      [timeRange]="selectedTimeRange()"
      [timeRangeName]="name"
      (timeRangeChange)="_handleTimeRangeChange($event)"
    ></calendar>
  } @else {
    <calendar
      [timeRangeView]="true"
      (timeRangeChange)="_handleTimeRangeChange($event)"
    ></calendar>
  }
</mat-menu>
